export default [{
  path: '/company',
  name: 'company',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/company/index')
}]
